const getDepartureChangeInfo = (change) => {
  return (
    change && {
      cancelled: /^(JOURNEY_CANCELLED|STOP_CANCELLED)$/.test(change?.state),
      newTo: change?.new_to,
      noStopBetween: change?.no_stop_between,
      noStopTill: change?.no_stop_till,
      oldTo: change?.old_to,
    }
  );
};

export default getDepartureChangeInfo;
